
 <!-- row 1 -->
 <div class="row row-data">
    <div class="col-lg-1 col-md-1 col-sm-1">
        <div class="imagebackground" style="background-image: url('https://res.cloudinary.com/orderfield/image/upload/c_scale,w_340/v1538578730/vanmanen/products/090727.jpg')">
            <div class="content"></div>
        </div>
    </div>
    <div class="col-lg-3 col-md-3 col-sm-3 top-padding">
        <span class="title">Sfeerlicht messing basis 3ass S dia6x10cm</span>
        <span class="productnumber">039845</span>
    </div>
    <div class="col-lg-1 col-md-1 col-sm-1 top-padding text-right col-quantity">315</div>
    <div class="col-lg-1 col-md-1 col-sm-1 top-padding text-right col-price">&#8364;4,50</div>
    <div class="col-lg-2 col-md-2 col-sm-2 top-padding">Orderstreet 12, London</div>
    <div class="col-lg-2 col-md-2 col-sm-2 top-padding text-right"><i class="fa fa-calendar-alt fa-grey"></i> 12-11-2018</div>
    <div class="col-lg-2 col-md-2 col-sm-2 top-padding text-right"><span class="backorder"><i class="fa fa-calendar-alt"></i> 09-01-2019</span></div>
</div>
